export const SupportedPaymentTypes = {
  WALLET: 'WALLET',
  DIRECT_CARD: 'DIRECT_CARD',
  DIRECT_BANK: 'DIRECT_BANK_ACCOUNT',
} as const

export type SupportedPaymentTypes =
  (typeof SupportedPaymentTypes)[keyof typeof SupportedPaymentTypes]

export type EwaSettings = {
  direct_enabled: boolean
  period_earnings: boolean
  withdrawal_percentage: number
}

export type TaxFilingSettings = {
  onboarding_require_w9_collection: boolean
}

export type OrganizationInfo = {
  id: number
  org_key: string
  name: string
  partner_id: number
  logo_url: string
  auto_join_default_location: boolean
  branding_color_hex_code: string
  default_location_id: string
  onboarding_redirect_deeplink: string
  require_roster_match_before_kyc: boolean
  app_identifier: string
  supported_payment_types: SupportedPaymentTypes[]
  app_display_name: string
  login_deep_link: string
  enable_unified_onboarding: boolean
  ewa: EwaSettings
  tax_filing: TaxFilingSettings
}

export interface OrganizationInfoResponse {
  data: OrganizationInfo[]
}

export const PayoutFeeType = {
  INSTANT: 'INSTANT',
  DELAYED: 'DELAYED',
  EWA_DIRECT: 'EWA_DIRECT',
} as const

export type PayoutFeeType = (typeof PayoutFeeType)[keyof typeof PayoutFeeType]

export interface PayoutFee {
  payout_fee_type: PayoutFeeType
  base_fee: number
  fee_percent: number
  max_fee: number | null
}
